import { faSearch } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { HEADER_SEARCH_DROPDOWN } from '../../brands/default/content/components/header';
import ThemeContext from '../../providers/ThemeProvider';
import Icon from '../Icon';

const HeaderSearchDropDown = ({
  dropDownTitle,
  liClickHandler,
  query,
  suggestionFocusIndex,
  suggestions,
}) => {
  const theme = useContext(ThemeContext);
  const bolden = (item) => {
    if (dropDownTitle === HEADER_SEARCH_DROPDOWN.topSearchesTitle) return item;
    if (!query) return item;
    const stringRegExp = new RegExp(query, 'g');

    return item.replace(stringRegExp, `<strong>${query}</strong>`);
  };

  return (
    <>
      <div className="search-suggestions" data-testid="search-suggestions">
        <h3>{dropDownTitle}</h3>
        <ul
          aria-label="Suggestions"
          className="suggestions-list"
          id="search-suggestions"
          role="listbox"
        >
          {suggestions &&
            suggestions.length > 0 &&
            suggestions.map((navItem, index) => {
              const listItemClass = classNames('search-item', {
                'search-item__selected': index === suggestionFocusIndex,
              });
              const liId = `suggest-li-${index}`;

              return (
                // keyboard navigation is in parent
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                <li
                  aria-selected={index === suggestionFocusIndex}
                  className={listItemClass}
                  id={liId}
                  key={liId}
                  onClick={() => {
                    // set search query and submit
                    liClickHandler(navItem);
                  }}
                  role="option"
                >
                  <Icon color="none" faIcon={faSearch} size="16px" />
                  <span dangerouslySetInnerHTML={{ __html: bolden(navItem) }} />
                  {/* <span>{navItem}</span>*/}
                </li>
              );
            })}
        </ul>
      </div>
      <style jsx>{`
        .search-suggestions {
          display: block;
          border-radius: 6px;
          box-shadow: 0 0 5px rgb(0 0 0 / 40%);
          position: absolute;
          top: 42px;
          left: 15px;
          width: 96.7%;
          background-color: ${theme.commoncolors.white};
          z-index: 1002;
          overflow: hidden;
        }
        .search-suggestions h3 {
          color: ${theme.colors.primary};
          padding: 5px 10px;
        }
        .suggestions-list {
          padding: 0;
          list-style-type: none;
        }
        .search-item {
          border: 0;
          background: none;
          cursor: pointer;
          display: block;
          color: ${theme.colors.bodytext};
          width: 100%;
          text-align: left;
          padding: 5px 10px;
        }
        .search-item span {
          margin-left: 6px;
        }
        .search-item:hover,
        .search-item__selected {
          background-color: ${theme.commoncolors.greyxlighter};
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .search-suggestions {
            top: 35px;
            width: 91%;
          }
        }
      `}</style>
    </>
  );
};

HeaderSearchDropDown.propTypes = {
  dropDownTitle: PropTypes.string,
  liClickHandler: PropTypes.func,
  query: PropTypes.string,
  suggestionFocusIndex: PropTypes.number,
  suggestions: PropTypes.array,
};

export default HeaderSearchDropDown;
